import CompLayout from "@/pcomponents/comp_stu/layout/layout";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

function Main(){
  let user=useSelector((state:any) => state.user);
  const navigate = useNavigate();
  useEffect(() => {
    //goMobilePage();
    navigate("/comp_stu/coolen/move");
  }, []);

  return (
    <CompLayout isLeftArea={false} isConTitle={false}>
      
    </CompLayout>
  );
}

export default Main;